import { render, staticRenderFns } from "./GeographicAreas.vue?vue&type=template&id=e8a376be&scoped=true"
import script from "./GeographicAreas.vue?vue&type=script&lang=js"
export * from "./GeographicAreas.vue?vue&type=script&lang=js"
import style0 from "./GeographicAreas.vue?vue&type=style&index=0&id=e8a376be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a376be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a376be')) {
      api.createRecord('e8a376be', component.options)
    } else {
      api.reload('e8a376be', component.options)
    }
    module.hot.accept("./GeographicAreas.vue?vue&type=template&id=e8a376be&scoped=true", function () {
      api.rerender('e8a376be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/GeographicAreas.vue"
export default component.exports